import { render, staticRenderFns } from "./RechargeDialog.vue?vue&type=template&id=56671b3f&scoped=true"
import script from "./RechargeDialog.vue?vue&type=script&lang=js"
export * from "./RechargeDialog.vue?vue&type=script&lang=js"
import style0 from "./RechargeDialog.vue?vue&type=style&index=0&id=56671b3f&prod&scoped=true&lang=css"
import style1 from "./RechargeDialog.vue?vue&type=style&index=1&id=56671b3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56671b3f",
  null
  
)

export default component.exports